import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const MarkMessageReadSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default MarkMessageReadSVG;
